import { render } from "./ImportBackupOffering.vue?vue&type=template&id=f70d4b3a&scoped=true"
import script from "./ImportBackupOffering.vue?vue&type=script&lang=js"
export * from "./ImportBackupOffering.vue?vue&type=script&lang=js"

import "./ImportBackupOffering.vue?vue&type=style&index=0&id=f70d4b3a&scoped=true&lang=less"

import exportComponent from "/mnt/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f70d4b3a"]])

export default __exports__